var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interaction"},[_c('div',{staticClass:"apparel"},[_c('div',{staticClass:"center"},[_c('div',{staticClass:"exchange"},[_c('h2',[_vm._v("智能穿戴")]),_c('h2',[_vm._v("数据采集")]),_c('p',[_vm._v("穿戴设备与AI算法协同下的实时人体数据采集")])])])])])
}]

export { render, staticRenderFns }